<template>
  <b-container fluid>
    <b-modal id="selbstdeklarationCMPmodal" :title="$t('Datenpakete_COOP_MODAL_TITLE')" size="xl">
      <b-container fluid v-if="!gtEmmiFreigabe">Bitte zuerst den grünen Teppich an Emmi freigeben</b-container>

      <b-container fluid v-if="dataLoaded&&gtEmmiFreigabe">
        <!-- wizardstep 0 Grundanforderungen -->
        <div v-show="anforderungen(1).length && wizardStep==0">
          <p v-html="paketCoop.text[$i18n.locale]"></p>
          <p>{{ $t('Datenpakete_COOP_Einleitungssatz1') }}</p>

          <div v-for="kriterium in anforderungen(1)" v-bind:key="kriterium.id"> 
            <selbstdeklaration-zeile :paketID="3" :kriteriumID="kriterium.id" :kriterium="kriterium" :disabled="true" />
          </div>

          <p>{{ $t('Datenpakete_COOP_Einleitungssatz2') }}</p>
          <div v-for="kriterium in anforderungen(2)" v-bind:key="kriterium.id">
            <selbstdeklaration-zeile :paketID="3" :kriterium="kriterium" :kriteriumID="kriterium.id" />
          </div>

          <template v-for="name in zwingend">
            <b-alert
              show
              v-if="alertZwingende(paketCoop.kriterien.filter(kritX => kritX.key == name)[0].value)"
              variant="warning"
              v-bind:key="name"
            >{{ $t('Datenpakete_COOP_GRUNDANFORDERUNG_'+name.toUpperCase()) }}</b-alert>
          </template>

          <b-alert
            show
            v-if="!cmpErfuellt"
            variant="warning"
          >{{ $t('Datenpakete_COOP_NICHTERFUELLT') }}</b-alert>

          <b-alert
            show
            v-if="allesAusgefuellt"
            variant="danger"
          >{{ $t('Datenpakete_COOP_ALLESAUSGEFUELLT') }}</b-alert>

          <p v-html="$t('Datenpakete_COOP_AGB_BegleitText')"></p>
          <b-form-checkbox
            id="AGBCOOP"
            v-model="agbCoop"
            name="agbCoop"
            value="accepted"
            unchecked-value="not_accepted"
          >
            <span v-html="$t('Datenpakete_COOP_AGB_CheckboxText')"></span>
          </b-form-checkbox>

          <b-alert
            show
            v-if="(agbCoop=='not_accepted')"
            variant="danger"
          >{{ $t('Datenpakete_COOP_AGB_NichtAkzeptiert') }}</b-alert>
        </div>

        <div v-show="wizardStep==1">
          <template>{{ $t('Datenpakete_COOP_Speichere_Text') }}</template>
        </div>
        <div v-show="wizardStep==2">
          <template>{{ $t('Datenpakete_COOP_Gespeichert_Text') }}</template>
        </div>
      </b-container>

      <div slot="modal-footer">
        <b-button
          v-show="wizardStep==0 "
          v-on:click="close"
          variant="secondary"
        >{{ $t('Abbrechen') }}</b-button>

        <b-button
          v-if="gtEmmiFreigabe"
          v-show="wizardStep==0"
          v-on:click="save"
          variant="primary"
          :disabled="agbCoop=='not_accepted'||allesAusgefuellt"
        >{{ $t('speichern') }}</b-button>

        <b-button v-show="wizardStep==2" v-on:click="close" variant="primary">{{ $t('close') }}</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import moment from "moment";
import { bus } from "../../main";
import SelbstdeklarationZeile from "./SelbstdeklarationZeile.vue";

export default {
  name: "Selbstdeklaration",
  data() {
    return {
      zwingend: ["GruenerTeppich", "RAUS", "CHRaufutter"] /* kriterien.key */,
      agbCoop: "not_accepted",
      wizardStep: 0,
      paketId: 3 /* Coop Teppich gemäss DB */,
      step: 0,
      freigaben: []
    };
  },
  computed: {
    dataLoaded() {
      return this.$store.state.datenpaketeStore.pakete.length > 0;
    },
    paketCoopArrRef() {
      return this.$store.state.datenpaketeStore.CMP.arrayRef;
    },
    paketCoop() {
      return this.$store.state.datenpaketeStore.pakete[this.paketCoopArrRef];
    },
    gtEmmiFreigabe() {
      //hat den wert null wenn grüner Teppich nicht ausgefüllt ..
      return this.$store.state.datenpaketeStore.CMP.gtEmmiFreigabe;
    },
    // steuert den speichern button
    allesAusgefuellt() {
      // sucht nicht ausgefüllte kriterien
      return this.paketCoop.kriterien.filter(krit => krit.value === null)
        .length == 0
        ? false
        : true;
    },
    k_gruenteppich() {
      return (
        this.paketCoop.kriterien.filter(krit => krit.key == "GruenerTeppich")[0]
          .value == 1
      );
    },
    k_bts() {
      return (
        this.paketCoop.kriterien.filter(krit => krit.key == "BTS")[0].value == 1
      );
    },
    k_raus() {
      return (
        this.paketCoop.kriterien.filter(krit => krit.key == "RAUS")[0].value ==
        1
      );
    },
    k_gmf() {
      return (
        this.paketCoop.kriterien.filter(krit => krit.key == "GMF")[0].value == 1
      );
    },
    k_raufutter() {
      return (
        this.paketCoop.kriterien.filter(krit => krit.key == "CHRaufutter")[0]
          .value == 1
      );
    },
    // steuert die Meldung
    cmpErfuellt() {
      return (
        this.k_gruenteppich &&
        this.k_raus &&
        this.k_raufutter &&
        (this.k_bts || this.k_gmf)
      );
    }
  },
  methods: {
    async initModal() {
      this.wizardStep = 0;
      this.agbCoop = "not_accepted";
    },
    save() {
      this.wizardStep++;
      this.$store.dispatch("savePaket", { id: this.paketId, declaration: true, approval: true });
    },
    async saveInProgressDone(savedPaketID) {
      if (savedPaketID != this.paketId) return;
      this.wizardStep++;
      if (this.wizardStep === 2) {
        // gespeichert ..
        await this.$store.dispatch("loadPakete");
        this.agb = "not_accepted";
      }
    },
    close() {
      this.$root.$emit("bv::hide::modal", "selbstdeklarationCMPmodal");
    },
    anforderungen(art) {
      return this.paketCoop.kriterien.filter(kritX => kritX.art == art);
    },
    convertTime(value) {
      return moment(value).format("DD.MM.YYYY");
    },
    alertZwingende(value) {
      /* blendet den alert ein */
      if (!value) return true; /* when null  */
      return value.toString() == "1" ? false : true;
    }
  },
  components: {
    "selbstdeklaration-zeile": SelbstdeklarationZeile
  },
  created() {},
  mounted() {
    let self = this;
    this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
      if (modalId == "selbstdeklarationCMPmodal") {
        this.initModal();
      }
    });
    bus.$on("paketSaved", self.saveInProgressDone);
  },
  updated() {}
};
</script>

<style scoped>
.active {
  font-weight: bold;
}
</style>